import { Component, OnInit, HostListener, ViewChild,Renderer2 } from '@angular/core';
import { TestsService } from '../../Services/Tests/TestsService';
import { Router, NavigationEnd } from '@angular/router';
import { LoginService } from '../../Services/GlobalServices/login.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../Services/Alert/Alert.service';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from '../../Services/canonical.service';
import { TestSuite, TestSuitesLandingDTO, TestSuiteStatus, TestStarReviews } from '../../../Models/Tests/tests.models';
declare var $: any;

@Component({
  selector: 'app-testslanding',
  templateUrl: './testslanding.component.html',
  styleUrls: ['./testslanding.component.scss']
})
export class TestslandingComponent implements OnInit {
  @ViewChild('testPopup', { static: false }) testPopup;
  constructor(private alertService: AlertService, private testsService: TestsService,private renderer:Renderer2, private loginService: LoginService, private modalService: NgbModal, private metaService: Meta, private titleService: Title, private canonicalService: CanonicalService, private router: Router) {
  }
  goToHome() {
    this.router.navigate(['/home']);
  }
  popupImageUrl: any;
  
  testSuites: TestSuitesLandingDTO[] = [];
  azuretestsuites: TestSuitesLandingDTO[] = [];
  DPtestsuites: TestSuitesLandingDTO[] = [];
  PLtestsuites: TestSuitesLandingDTO[] = [];
  SCtestsuites: TestSuitesLandingDTO[] = [];
  Careertestsuites: TestSuitesLandingDTO[] = [];
  AITestsSuites: TestSuitesLandingDTO[] = [];
  Miscellaneous: TestSuitesLandingDTO[] = [];

  sortedTestSuites: TestSuite[] = [];
  teststarreview: TestStarReviews;
  //collectionSize: number;
  //skipTests: number = 0;
  //pageLength: number = 20;
  userrole: string;
  userId: string;
  pkTestSuiteId: string;
  previousSort: number;
  isMobileView: boolean;
  windowWidth: number;
  totalQues: number;
  timeLeft: number = 10;
  isStrip: boolean = false;
  imageSrc = 'https://a2zstorageaccount.blob.core.windows.net/a2zcontainer/Popups/Learn%20Complete%20Azure%20Suite.jpg'
  imageAlt = 'POPUP'
  RoutingURL = 'https://www.bestitcourses.com/courses-and-webinars/?source=a2zbnAZ';
  b: boolean = false;
  testSuiteDomain: string = "Azure Certification Dumps";
  interval;

  ngOnInit() {

    $(document).ready(function () {
      //navbar
      $(".hveffe").click(function () {
        $(".textdecorator").css("text-decoration", "");
        $(".textdecorator").css("border-bottom-style", "");
        $(".textdecorator").css("border-bottom-color", "");
        $(".textdecorator").css("border-bottom-width", "");
        $(".textdecoratorNewfirst").css("border-bottom-style", "");
        $(".textdecoratorNewfirst").css("border-bottom-color", "");
        $(".textdecoratorNewfirst").css("border-bottom-width", "");
        $(".textdecoratorOldSecond").css("border-bottom-style", "");
        $(".textdecoratorOldSecond").css("border-bottom-color", "");
        $(".textdecoratorOldSecond").css("border-bottom-width", "");
        $(".txthover").css("text-decoration", "");
        $(".textdecoratorNewfirst").css("text-decoration", "")
        $(".textdecoratorNew").css("text-decoration", "");
        $(".textdecoratorOldSecond").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        $(".ex2").css("text-decoration", "");
        $("#cnt").css("background-color", "");
        $(".hveffe").css("text-decoration", "");
        //$(".hveffec").css("text-decoration", "underline");
        //$(".hveffec").css("text-decoration-color", "dodgerblue");
        $(".hveffec").css("border-bottom-style", "groove");
        $(".hveffec").css("border-bottom-color", "dodgerblue");
        $(".hveffec").css("border-bottom-width", "3px");
        //$(this).css("text-decoration", "underline");
        //$(this).css("text-decoration-color", "dodgerblue");
      });
      $(".textdecorator").click(function () {
        $(".itemMenu").css("background-color", "");
        $(".textdecorator").css("text-decoration", "");
        $(".txthover").css("text-decoration", "");
        $(".textdecoratorNewfirst").css("text-decoration", "")
        $(".textdecoratorNew").css("text-decoration", "");
        $(".textdecoratorOldSecond").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        $(".ex2").css("text-decoration", "");
        $(".hveffe").css("text-decoration", "");
        $(".hveffec").css("text-decoration", "");
        $(".hveffec").css("text-decoration", "");
        $(".hveffec").css("border-bottom-style", "");
        $(".hveffec").css("border-bottom-color", "");
        $(".hveffec").css("border-bottom-width", "");
        $(".textdecoratorNewfirst").css("border-bottom-style", "");
        $(".textdecoratorNewfirst").css("border-bottom-color", "");
        $(".textdecoratorNewfirst").css("border-bottom-width", "");
        $(".textdecoratorOldSecond").css("border-bottom-style", "");
        $(".textdecoratorOldSecond").css("border-bottom-color", "");
        $(".textdecoratorOldSecond").css("border-bottom-width", "");
        $("#cnt").css("background-color", "");
        $(".textdecorator").css("border-bottom-style", "");
        $(".textdecorator").css("border-bottom-color", "");
        $(".textdecorator").css("border-bottom-width", "");
        $(this).css("border-bottom-style", "groove");
        $(this).css("border-bottom-color", "dodgerblue");
        $(this).css("border-bottom-width", "3px");
      });
      //$("#cnt").click(function () {
      //    $(".textdecorator").css("text-decoration", "");
      //    $(".txthover").css("text-decoration", "");
      //      $(".textdecoratorNewfirst").css("text-decoration", "")
      //        $(".textdecoratorNew").css("text-decoration", "");
      //        $(".textdecoratorOldSecond").css("text-decoration", "");
      //        $(".textdecoratorOld").css("text-decoration", "");
      //        $(".ex2").css("text-decoration", "");
      //      $(".hveffe").css("text-decoration", "");
      //      $(".hveffec").css("text-decoration", "");
      //    $("#cnt").css("background-color", "");
      //  $(this).css("border-bottom-style", "groove");
      //  $(this).css("border-bottom-color", "dodgerblue");
      //  $(this).css("border-bottom-width", "3px");
      //});
      //   //togglebar
      $(".textdecoratorNew").click(function () {
        $(".textdecorator").css("text-decoration", "");
        $(".txthover").css("text-decoration", "");
        $(".textdecoratorOldSecond").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        //$(".textdecoratorNewfirst").css("text-decoration", "underline");
        //$(".textdecoratorNewfirst").css("text-decoration-color", "dodgerblue");
        $(".textdecoratorNew").css("text-decoration", "");
        $(".hveffe").css("text-decoration", "");
        $(".hveffec").css("text-decoration", "");
        $("#cnt").css("background-color", "");
        $(".textdecorator").css("border-bottom-style", "");
        $(".textdecorator").css("border-bottom-color", "");
        $(".textdecorator").css("border-bottom-width", "");
        $(".hveffec").css("border-bottom-style", "");
        $(".hveffec").css("border-bottom-color", "");
        $(".hveffec").css("border-bottom-width", "");
        $(".textdecoratorOldSecond").css("border-bottom-style", "");
        $(".textdecoratorOldSecond").css("border-bottom-color", "");
        $(".textdecoratorOldSecond").css("border-bottom-width", "");
        //$(this).css("text-decoration", "underline");
        //$(this).css("text-decoration-color", "dodgerblue");
        $(".textdecoratorNewfirst").css("border-bottom-style", "groove");
        $(".textdecoratorNewfirst").css("border-bottom-color", "dodgerblue");
        $(".textdecoratorNewfirst").css("border-bottom-width", "3px");
      });
      $(".textdecoratorOld").click(function () {
        $(".textdecorator").css("text-decoration", "");
        $(".textdecoratorNewfirst").css("text-decoration", "");
        $(".textdecoratorNew").css("text-decoration", "");
        $(".txthover").css("text-decoration", "");
        //$(".textdecoratorOldSecond").css("text-decoration", "underline");
        // $(".textdecoratorOldSecond").css("text-decoration-color", "dodgerblue");
        $(".textdecoratorOldSecond").css("border-bottom-style", "groove");
        $(".textdecoratorOldSecond").css("border-bottom-color", "dodgerblue");
        $(".textdecoratorOldSecond").css("border-bottom-width", "3px");
        $("#cnt").css("background-color", "");
        $(".hveffe").css("text-decoration", "");
        $(".hveffec").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        $(".textdecorator").css("border-bottom-style", "");
        $(".textdecorator").css("border-bottom-color", "");
        $(".textdecorator").css("border-bottom-width", "");
        $(".hveffec").css("border-bottom-style", "");
        $(".hveffec").css("border-bottom-color", "");
        $(".hveffec").css("border-bottom-width", "");
        $(".textdecoratorNewfirst").css("border-bottom-style", "");
        $(".textdecoratorNewfirst").css("border-bottom-color", "");
        $(".textdecoratorNewfirst").css("border-bottom-width", "");
        //$(this).css("text-decoration", "underline");
        //$(this).css("text-decoration-color", "dodgerblue");
      });
      $(".itemMenu").click(function () {
        $(".itemMenu").css("background-color", "");
        $(this).css("background-color", "#E4E5E7");
      });
      //$(".itemMenu").hover(function () {
      //  $(".itemMenu").css("background-color", "");
      //  $(this).css("background-color", "#f8f9fa");
      //  $(this).css("border-radius", "12px");
      //});
      //  //Dashboard
      $(".txthover").click(function () {
        $(".textdecorator").css("text-decoration", "");
        $(".textdecoratorNewfirst").css("text-decoration", "");
        $(".textdecoratorNew").css("text-decoration", "");
        $(".textdecoratorOldSecond").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        $(".hveffe").css("text-decoration", "");
        $(".hveffec").css("text-decoration", "");
        $("#cnt").css("background-color", "");
        $(".txthover").css("text-decoration", "");
        $(".textdecoratorOld").css("text-decoration", "");
        $(".textdecorator").css("border-bottom-style", "");
        $(".textdecorator").css("border-bottom-color", "");
        $(".textdecorator").css("border-bottom-width", "");
        $(".hveffec").css("border-bottom-style", "");
        $(".hveffec").css("border-bottom-color", "");
        $(".hveffec").css("border-bottom-width", "");
        $(".textdecoratorNewfirst").css("border-bottom-style", "");
        $(".textdecoratorNewfirst").css("border-bottom-color", "");
        $(".textdecoratorNewfirst").css("border-bottom-width", "");
        $(".textdecoratorOldSecond").css("border-bottom-style", "");
        $(".textdecoratorOldSecond").css("border-bottom-color", "");
        $(".textdecoratorOldSecond").css("border-bottom-width", "");
        //$(this).css("text-decoration", "underline");
        //$(this).css("text-decoration-color", "dodgerblue");
      });
    });
    window.scrollTo(0, 0);
    this.userrole = this.loginService.getRole();
    this.userId = this.loginService.getCurrentUserId();
    this.initializeTestSuites();
    //if (this.userrole == "Admin") {
    //  this.getPagedTests(this.skipTests, Sort.Admin);
    //}
    //else {
    //  this.getPagedTests(this.skipTests, Sort.Title);
    //}
    //this.getNumberofTestSuites(this.userrole);
    this.titleService.setTitle('Latest Exam Questions on Cloud Certification at  Azure A2Z');
    //this.metaService.removeTag('keywords');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Update meta tags dynamically for the component
        this.addTags();
      }
    });
    this.canonicalService.setCanonicalURL();
    this.addScript('application/ld+json', `
   {
     "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
    "@type": "ListItem", "position": 1,
    "name": "Home", "item": "https://www.azurea2z.com/"
    },{
    "@type": "ListItem",
    "position": 2,
    "name": "Exams",
    "item": "https://www.azurea2z.com/exams"
    }]
   }
`);
    //this.startPopupTimer();    
  } 

  private addScript(type: string, content: string): void {
    const script = this.renderer.createElement('script');
    script.type = type;
    script.text = content;
    this.renderer.appendChild(document.head, script);
  }

  testSuiteJudgement(judgementPanel, pkTestSuiteId: string) {
    this.pkTestSuiteId = pkTestSuiteId;
    this.modalService.open(judgementPanel, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => { result.result.then(() => { }, () => { }); })
  }

  ApproveorDisapproveTestSuite(n: number) {
    this.testsService.ApproveorDisapproveTestSuite(this.pkTestSuiteId, n).subscribe();
    let ts: TestSuitesLandingDTO = this.testSuites.find(testSuite => testSuite.PKTestSuiteId == this.pkTestSuiteId);
    if (n == 1) {
      ts.Status = TestSuiteStatus.Approved;
      this.alertService.success("Approved!");
    }
    else if (n == 2) {
      ts.Status = TestSuiteStatus.Rejected;
      this.alertService.success("Rejected!");
    }
    this.modalService.dismissAll();
  }


  initializeTestSuites() {
    this.testsService.getAllTestSuites(this.userrole, this.userId).subscribe((res) => {
      this.testSuites = res;
     // console.log(this.testSuites);
      this.azuretestsuites = this.testSuites.filter(x =>
        x.TestSuiteTitle.includes('AZ-') || x.TestSuiteTitle.includes('Docker')
      );
      this.DPtestsuites = this.testSuites.filter(x => x.TestSuiteTitle.includes('DP-'))
      this.PLtestsuites = this.testSuites.filter(x => x.TestSuiteTitle.includes('PL-'))
      this.SCtestsuites = this.testSuites.filter(x => x.TestSuiteTitle.includes('SC-'))
      this.Careertestsuites = this.testSuites.filter(x => x.TestSuiteTitle.includes('Career'))
      this.AITestsSuites = this.testSuites.filter(x => x.TestSuiteTitle.includes('AI'))
      this.Miscellaneous = this.testSuites.filter(
        x => !x.TestSuiteTitle.includes('AZ-') &&
          !x.TestSuiteTitle.includes('Docker') &&
          !x.TestSuiteTitle.includes('DP-') &&
          !x.TestSuiteTitle.includes('PL-') &&
          !x.TestSuiteTitle.includes('SC-') &&
          !x.TestSuiteTitle.includes('Career') &&
          !x.TestSuiteTitle.includes('AI')
      );
          //let largestNumber: number = Number(this.testSuites[0].TotalLearners);
      let largestNumber: number = 0;



      for (let i = 0; i <= this.testSuites.length - 1; i++) {
        if (Number(this.testSuites[i].TotalLearners) > largestNumber) {
          largestNumber = Number(this.testSuites[i].TotalLearners);
          this.isStrip = true;
          this.testSuites[i].GradeSuite = "Most Popular"
        }

      }
      for (let i = 0; i <= this.testSuites.length - 1; i++) {

        this.testSuites[i].AttemptQsPercentage = Math.round((this.testSuites[i].AttemptQsPercentage / this.testSuites[i].totalCountQues) * 100);
        this.testSuites[i].AttemptQsPercentageNew = this.testSuites[i].AttemptQsPercentage + "%";



        switch (this.testSuites[i].TestSuiteTitle) {
          case 'AZ-900 Microsoft Azure Fundamentals - Old':
            this.testSuites[i].BarColor = "darkolivegreen";
            // this.testSuites[i].GradeSuite = true;
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "12,926"
            this.testSuites[i].GradeSuite = "Most Popular"

            break;
          case 'AZ-400: Designing and Implementing Microsoft DevOps Solutions':
            this.testSuites[i].BarColor = "red";
            // this.testSuites[i].GradeSuite = true;
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners ="734"
            break;
          case 'DP-203: Data Engineering on Microsoft Azure':
            this.testSuites[i].BarColor = "darkorange"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "1,020"
            break;
          case 'AZ-104: Microsoft Azure Administrator':
            this.testSuites[i].BarColor = "orange"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "2,699"
            break;
          case 'AZ-900: Microsoft Azure Fundamentals':
            this.testSuites[i].BarColor = "green"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "2,732"
            //this.testSuites[i].GradeSuite = "Most Popular"

            break;
          case 'AZ-500: Microsoft Azure Security Technologies':
            this.testSuites[i].BarColor = "CadetBlue"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "643"
            break;
          case 'Containarization using Docker':
            this.testSuites[i].BarColor = "#85509d"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "689"
            break;
          case 'AZ-305: Designing Microsoft Azure Infrastructure Solutions':
            this.testSuites[i].BarColor = "blueviolet";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "600"            
            break;
          case 'AZ-204: Developing Solutions for Microsoft Azure':
            this.testSuites[i].BarColor = "Purple";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "9,100"
            break;
          case 'DP-900: Azure Data Fundamentals':
            this.testSuites[i].BarColor = "MediumSlateBlue";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "2,100"
            break;
          case 'PL-100: Microsoft Power Platform App Maker':
            this.testSuites[i].BarColor = "Olive";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "86"

            break;
          case 'PL-900: Power Platform Fundamentals ':
            this.testSuites[i].BarColor = "DarkTurquoise";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "420"
            break;
          case 'PL-200: Microsoft Power Platform Functional Consultant':
            this.testSuites[i].BarColor = "Chocolate";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "89"            
            break;
          case 'PL-300: Microsoft Power BI Data Analyst':
            this.testSuites[i].BarColor = "Cornflowerblue";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "70"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'SC-200: Microsoft Security Operations Analyst':
            this.testSuites[i].BarColor = "Plum";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "50"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'SC-300: Microsoft Identity and Access Administrator':
            this.testSuites[i].BarColor = "DarkTurquoise";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "68"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'SC-400: Microsoft Information Protection Administrator':
            this.testSuites[i].BarColor = "Green";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "45"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'Docker Certified Associate':
            this.testSuites[i].BarColor = "fuchsia";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "45"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'AZ-900: Azure Fundamentals Learning Path':
            this.testSuites[i].BarColor = "Terra Cotta";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
           // this.testSuites[i].TotalLearners = "45"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'PL-400: Microsoft Power Platform Developer':
            this.testSuites[i].BarColor = "Marsala";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "12"
            this.testSuites[i].GradeSuite = "New"
            break;
          case 'AI-900: Azure AI Fundamentals':
            this.testSuites[i].BarColor = "Marsala";
            //this.testSuites[i].GradeSuite="most popular"
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            //this.testSuites[i].TotalLearners = "45"
            this.testSuites[i].GradeSuite = "New"
            break;
          default:
            this.testSuites[i].BarColor = "red";
            this.testSuites[i].TotalLearners = this.addComma(Number(this.testSuites[i].TotalLearners));
            break;
        }

        // this.percent = $"{this.testSuites[i].AttemptQsPercentage}";
        // this.progressBarStyle = { 'width': 50px};
      }
      //for (var i = 0; i < this.testSuites.length; i++) {
      //  this.testsService.getCountofquesByPathId(this.testSuites[i].PathId).subscribe((res) => {
      //    this.totalQues = res;
      //  })
      //}
    });

  }




  //getPagedTests(skip: number, sort: number, keyword?: string) {
  //  this.previousSort = sort;
  //  this.testsService.GetPagedTestSuites(skip, this.pageLength, sort, keyword, this.userId).subscribe((res) => {
  //    this.testSuites = res.Result;
  //  })
  //}

  //getNumberofTestSuites(userRole: string) {
  //  this.testsService.GetNumberofTestSuites(userRole).subscribe((res) => {
  //    this.collectionSize = res;
  //  })
  //}

  //pageChanged(number) {
  //  window.scrollTo(0, 0);
  //  if (number == 1) {
  //    this.skipTests = 0;
  //  }
  //  else {
  //    this.skipTests = (number - 1) * this.pageLength;
  //  }
  //  this.getPagedTests(this.skipTests, this.previousSort);
  //}

  delete(event) {
    event.stopPropagation();
  }

  ngAfterViewInit(): void {
    this.OnResize();
  }

  @HostListener("window:resize")
  private OnResize() {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth <= 420) {
      this.isMobileView = true;
    }
    else {
      this.isMobileView = false;
    }
  }

  addTags() {
    this.metaService.updateTag({ property: 'keywords', content: 'exam questions, az 900 practice test, cloud certification, az 104 exam, microsoft free certification courses, free microsoft certifications, microsoft certification for free, microsoft exam, it basic certifications, it exams, microsoft exam, ai 900 dumps, pl 900 exam, az 900 exam topics, az 400 exam, exam site, its certification' });
    this.metaService.updateTag({ property: 'description', content: 'Increase your knowledge and be prepared for the Micrsoft Certification with us, Try out our Azure Certification exam dumps and clear your certification in one shot.' });
    this.metaService.updateTag({ property: 'og:title', content: 'Microsoft Azure Certification Exams | Azure Certification Exam Practice & Quiz' });
    this.metaService.updateTag({ property: 'og:description', content: 'Start your practice today to get success on the Azure Certification exam, from this AzureA2z website. Here, you will be able to practice on Azure certification, you will get confidence on Azure Certification exam with Azure quiz, and more information you will get from here.' });
    this.metaService.updateTag({ property: 'twitter:title', content: 'Microsoft Azure Certification Exams | Azure Certification Exam Practice & Quiz' });
    this.metaService.updateTag({ property: 'twitter:description', content: 'Start your practice today to get success on the Azure Certification exam, from this AzureA2z website. Here, you will be able to practice on Azure certification, you will get confidence on Azure Certification exam with Azure quiz, and more information you will get from here.' });
  }
  startPopupTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        if (this.timeLeft == 0) {
        }
      }
      else {
        clearInterval(this.interval);

        let ngbModalOptions: NgbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          ariaLabelledBy: 'modal-basic-title'
        };
        this.modalService.open(this.testPopup, ngbModalOptions).result.then((result) => { result.result.then(() => { }, () => { }); }).catch((res) => { });
      }
    }, 600)

  }
  close() {
    this.modalService.dismissAll();
    //window.scrollTo(0, 0);
  }
  //comma separated function
  //addComma(totalLearners: string): string {
  //      var learnString = totalLearners.toString();
  //      const arr = learnString.split('');
  //      arr.reverse();
  //      //val:string = "";
  //      for (let i = 3; i <= arr.length - 1; i += 4) {
  //        arr.splice(i, 0, ',');
  //      }
  //      var r = arr.reverse().join('');
  //        totalLearners = r;
  //    return totalLearners
  //    }

  addComma = (num: number): string => {
    return num.toLocaleString('en-US');
  }



}

enum Sort {
  Admin = 0,
  Title,
  DateUpdated,
  Price,
  PurchaseCount,
  Search
}
